import LegalLayout, { LegalSection } from "@/components/site/LegalLayout";
import { BRAND } from "@/lib/brand";

export default function CookiePolicy() {
  return (
    <LegalLayout
      title="Cookie Policy"
      kicker="Informativa Cookie — Provv. Garante 10/06/2021"
      testId="cookie-policy-page"
    >
      <p className="text-[16px] italic font-serif-display text-[#0A0A0A]">
        Questa Cookie Policy spiega quali cookie utilizza il sito{" "}
        <strong>www.lavalledegliiblei.it</strong> e come puoi gestirli.
      </p>

      <LegalSection num="01" title="Cosa sono i Cookie">
        <p>
          I cookie sono piccoli file di testo che i siti visitati salvano sul
          tuo dispositivo. Vengono usati per far funzionare il sito o per
          migliorarne le prestazioni e l'esperienza utente.
        </p>
      </LegalSection>

      <LegalSection num="02" title="Cookie Utilizzati">
        <p>
          Questo sito utilizza esclusivamente <strong>cookie tecnici
          essenziali</strong>, necessari al funzionamento corretto e alla
          memorizzazione delle tue preferenze (es. scelta sui cookie).
        </p>
        <p>
          <strong className="text-[#0A0A0A]">
            Non utilizziamo cookie di profilazione, di marketing o di tracciamento
            pubblicitario di terze parti.
          </strong>
        </p>
        <div className="overflow-x-auto mt-6">
          <table className="w-full text-sm border border-[#EAEAEA]">
            <thead className="bg-[#FDFBF7]">
              <tr>
                <th className="text-left p-3 border-b border-[#EAEAEA] overline text-[10px]">Nome</th>
                <th className="text-left p-3 border-b border-[#EAEAEA] overline text-[10px]">Tipo</th>
                <th className="text-left p-3 border-b border-[#EAEAEA] overline text-[10px]">Durata</th>
                <th className="text-left p-3 border-b border-[#EAEAEA] overline text-[10px]">Finalità</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-3 border-b border-[#EAEAEA] font-mono text-xs">vdi_cookie_consent_v1</td>
                <td className="p-3 border-b border-[#EAEAEA]">Tecnico (localStorage)</td>
                <td className="p-3 border-b border-[#EAEAEA]">Persistente</td>
                <td className="p-3 border-b border-[#EAEAEA]">Memorizza la tua scelta sui cookie</td>
              </tr>
            </tbody>
          </table>
        </div>
      </LegalSection>

      <LegalSection num="03" title="Gestione dei Cookie">
        <p>
          Puoi gestire o disabilitare i cookie direttamente dalle impostazioni
          del tuo browser. Tieni presente che disabilitare i cookie tecnici
          potrebbe compromettere alcune funzionalità del sito.
        </p>
        <ul className="list-disc pl-6 space-y-2 marker:text-[#C4A671]">
          <li>
            <a className="underline" href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a>
          </li>
          <li>
            <a className="underline" href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a>
          </li>
          <li>
            <a className="underline" href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Apple Safari</a>
          </li>
          <li>
            <a className="underline" href="https://support.microsoft.com/it-it/microsoft-edge" target="_blank" rel="noopener noreferrer">Microsoft Edge</a>
          </li>
        </ul>
      </LegalSection>

      <LegalSection num="04" title="Contatti">
        <p>
          Per qualsiasi domanda relativa a questa Cookie Policy o al
          trattamento dei dati personali, contatta:{" "}
          <a href={`mailto:${BRAND.email}`} className="underline">
            {BRAND.email}
          </a>
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
